import { render, staticRenderFns } from "./historicalMigration.vue?vue&type=template&id=0c3045d9&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./historicalMigration.vue?vue&type=style&index=0&id=0c3045d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3045d9",
  null
  
)

export default component.exports